angular.module('salesPath2')
  .controller('apkMissingModalCtrl', ['$scope', '$window', 'apkErrorsHelper',
    function($scope, $window, apkErrorsHelper) {

      /**
      * init
      */
      $scope.init = function() {        
        $scope.fireListeners();
      };

      /**
       * Odpalenie watchy
       */
      $scope.fireListeners = function() {
        // continue
        $scope.$on('iHestiaCommonModalOkBtnClicked.apkMissingModal', function() {
          $window.open(apkErrorsHelper.portalUrl, '_self');
        });
      };

      $scope.init();

    }
  ]);
